export default __webpack_public_path__ + "static/media/8t.6a46ed79.jpg";